import React from 'react';
import { FormBuilder } from 'commons-ui';

import { FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG, validationSchema } from './formConfig';

import useCreate from './useCreate';

const CreateLayout: React.FC<{}> = () => {
	const { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useCreate();

	return (
		<FormBuilder
			data={data}
			mode='create'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			validationSchema={validationSchema}
			setShowLoader={setShowLoader}
			fieldConfig={FORM_FIELD_CONFIG}
			layoutConfig={FORM_LAYOUT_CONFIG}
			dependencies={[]}
		/>
	);
};

export default CreateLayout;
